import { sparkPath } from '@/lib/home';

/** A small line of the period, one hue, drawn left to right once. */
export function Sparkline({ series, soft = false }: { series: number[]; soft?: boolean }) {
  const w = 300;
  const h = 34;
  return (
    <svg
      className="h-spark"
      viewBox={`0 0 ${w} ${h}`}
      preserveAspectRatio="none"
      aria-hidden="true"
      style={{ width: '100%', height: h, display: 'block' }}
    >
      <path d={sparkPath(series, w, h)} className={soft ? 'soft' : undefined} />
    </svg>
  );
}
